import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { deliveryClient } from './deliveryClient'

const deliveryRequest = async <T>(options: AxiosRequestConfig) => {
  const onSuccess = (response: AxiosResponse<T>) => response.data

  const onError = (error: AxiosError) => Promise.reject(error)

  return deliveryClient(options).then(onSuccess).catch(onError)
}

export default deliveryRequest
